export enum ViewingMode {
  Tap = 'tap',
  Scroll = 'scroll',
}
